import MainLayout from '@/layouts/MainLayout.vue';

const externalRouters = {
    path: '/',
    component: MainLayout,
    children: [
        // {
        //     path: '/faq',
        //     name: 'Faq',
        //     // lazy load
        //     component: () => import('../pages/index.vue'),
        //     meta: {
        //         isCustomLang: true,
        //     },
        // },
    ],
};

export const faqRoute = [externalRouters];
